import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=3f547a48&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports